import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls';

import type { LastWorkspace, LastWorkspaceWriteStatus } from './types';

const LAST_WORKSPACE_STORAGE_KEY_PREFIX = 'studio-last-workspace';

export const getLastWorkspaceStorageKey = (atlassianAccountId: string): string =>
	`${LAST_WORKSPACE_STORAGE_KEY_PREFIX}-${atlassianAccountId}`;

const isLastWorkspace = (value: unknown): value is LastWorkspace => {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	const { workspaceId, writtenAt } = value as Record<string, unknown>;
	return typeof workspaceId === 'string' && workspaceId !== '' && typeof writtenAt === 'number';
};

export const readLastWorkspace = (atlassianAccountId: string): LastWorkspace | undefined => {
	try {
		const storedValue = AtlBrowserStorageLocal.getItem(
			getLastWorkspaceStorageKey(atlassianAccountId),
		);
		if (!storedValue) {
			return undefined;
		}
		const parsedValue: unknown = JSON.parse(storedValue);
		return isLastWorkspace(parsedValue) ? parsedValue : undefined;
	} catch {
		return undefined;
	}
};

/**
 * Never rejects: storage writes are consent-gated and must not affect routing.
 */
export const writeLastWorkspace = async (
	atlassianAccountId: string,
	workspaceId: string,
): Promise<LastWorkspaceWriteStatus> => {
	const value: LastWorkspace = { workspaceId, writtenAt: Date.now() };
	try {
		const result = await AtlBrowserStorageLocal.setItem(
			getLastWorkspaceStorageKey(atlassianAccountId),
			JSON.stringify(value),
		);
		return result?.status ?? 'NO_RESULT';
	} catch {
		return 'ERROR';
	}
};
